export const mockInquiries = [
  {
    id: '1',
    name: 'Takeshi Yamamoto',
    email: 'yamamoto@example.com',
    phone: '090-1234-5678',
    message: 'I am interested in building a custom home in Kyoto.',
    timestamp: new Date('2025-08-15T10:30:00')
  },
  {
    id: '2',
    name: 'Yuki Tanaka',
    email: 'tanaka@example.com',
    phone: '080-9876-5432',
    message: 'Looking for information on sustainable building materials.',
    timestamp: new Date('2025-08-14T14:20:00')
  }
];

export const testimonials = [
  {
    id: 1,
    name: '田中 美咲',
    location: '京都',
    text: 'Komorebi Homesの職人技に感動しました。細部へのこだわりと自然との調和が素晴らしいです。',
    rating: 5
  },
  {
    id: 2,
    name: '山本 健太',
    location: '東京',
    text: '私たちの夢の家を実現してくれました。伝統的な技術と現代的なデザインの融合が完璧です。',
    rating: 5
  },
  {
    id: 3,
    name: '佐藤 結衣',
    location: '大阪',
    text: '最初の相談から完成まで、すべてのプロセスが丁寧でプロフェッショナルでした。',
    rating: 5
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: 'Modern Zen Residence',
    location: 'Kyoto',
    image: 'https://images.pexels.com/photos/6692145/pexels-photo-6692145.jpeg',
    description: 'A harmonious blend of traditional Japanese aesthetics and contemporary living'
  },
  {
    id: 2,
    title: 'Minimalist Forest Home',
    location: 'Nagano',
    image: 'https://images.pexels.com/photos/6692153/pexels-photo-6692153.jpeg',
    description: 'Seamless integration with nature through thoughtful design'
  },
  {
    id: 3,
    title: 'Urban Sanctuary',
    location: 'Tokyo',
    image: 'https://images.pexels.com/photos/35268991/pexels-photo-35268991.jpeg',
    description: 'A peaceful retreat in the heart of the city'
  },
  {
    id: 4,
    title: 'Coastal Hideaway',
    location: 'Kamakura',
    image: 'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg',
    description: 'Natural light and ocean views define this serene space'
  },
  {
    id: 5,
    title: 'Mountain Retreat',
    location: 'Hakone',
    image: 'https://images.pexels.com/photos/35285762/pexels-photo-35285762.jpeg',
    description: 'Elevated living with panoramic mountain vistas'
  },
  {
    id: 6,
    title: 'Garden Villa',
    location: 'Nara',
    image: 'https://images.pexels.com/photos/11025254/pexels-photo-11025254.jpeg',
    description: 'Where indoor and outdoor spaces flow seamlessly'
  }
];